import React from 'react';
import { Button } from '@myua/kit';
import { PlusOutlined } from '@ant-design/icons';
import { AddSquare } from '@myua/icons/dist/bulk14';
import { useDispatch, useSelector } from 'react-redux';
import * as tagBinderActions from '../actions';
import { BindTagsModal } from './BindTagsModal';
import { getPermissions } from '../../app/selectors';
import { Permission } from '../../../../general/model';

export const useCanBindTags = () => {
  const permissions = useSelector(getPermissions);
  return permissions[Permission['fs.assetlab_set_tag_to_asset']];
};

export const BindTagsButtonSingle: React.FC<{ showText: boolean }> = ({ showText }) => {
  const dispatch = useDispatch();

  const canBindTags = useCanBindTags();
  if (!canBindTags) {
    return null;
  }

  return (
    <>
      <Button
        className="al-tag-binder-button-single al-btn-blue-icon"
        size="small"
        icon={<AddSquare />}
        onClick={() => dispatch(tagBinderActions.setVisible({ visible: true }))}
      >
        {showText ? 'Add tags' : ''}
      </Button>
      <BindTagsModal />
    </>
  );
};

export const BindTagsButtonMultiple = () => {
  const dispatch = useDispatch();

  const canBindTags = useCanBindTags();
  if (!canBindTags) {
    return null;
  }

  return (
    <>
      <Button
        icon={<PlusOutlined />}
        onClick={() => dispatch(tagBinderActions.setVisible({ visible: true }))}
      >
        Add tags
      </Button>
      <BindTagsModal />
    </>
  );
};
